import React from 'react';
import styles from './style.module.css';

import waterLoader from '../../../assets/water-loader.gif';
import spinnerLoader from '../../../assets/spinner-loader.gif';

export default function LoadingSpinner(props) {
  const { className } = props;

  const classes = [styles.root, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <img src={waterLoader} alt=" " />
      {/* <img src={spinnerLoader} alt=" " /> */}
    </div>
  );
}
